module.exports = __webpack_public_path__ + "static/media/health.eaebf3e8.jpg";